


























































































/* eslint-disable */
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Services, Apis, Factories } from '@finx/web-repository'
import { Auth } from '@finx/web-repository/src/services/Oidc'

import Moment from 'moment'

@Component
export default class ViewProducaoImpressao extends Vue {
  producao: [] = []
  usuario: any = {}
  dialog = true
  placeHolderMsg = 'Digite suas observações'
  loading: any = {
    status: false,
    text: 'Carregando...',
  }

  get getPlaceHolderMsg() {
    return this.placeHolderMsg
  }

  set getPlaceHolderMsg(value) {
    this.placeHolderMsg = value
  }

  async getProducaoById(producaoId) {
    const producao = {
      producaoId,
      page: 1,
    }

    const request = await Apis.Legacy.Producao.getProducaoPrintV2(producao)
    const success = Factories.Apis.success(request)

    if (success) {
      this.producao = request.data
    }
  }

  styleProcedimento(index, total) {
    let style = ''
    if (index < total--) {
      style = 'border-bottom: 1px solid #E7EAED;'
    }

    if (index > 0) {
      style += 'margin-top: 20px;'
    }

    return style
  }

  formatterDate(date) {
    return Moment(date).format('DD/MM/YYYY')
  }

  getDate() {
    const date = Date.now()
    return Moment(date).format('DD/MM/YYYY')
  }

  async getUser() {
    this.usuario = this.$user.profile
  }

  print() {
    this.$ga.event('producao', 'impressao', this.usuario.email)
    window.print()
  }

  async mounted() {
    this.loading.status = true
    if (this.$route.params.producaoId !== undefined) {
      await this.getProducaoById(this.$route.params.producaoId)
    }
    this.loading.status = false

    this.getUser()
  }
}
